export default __webpack_public_path__ + "static/media/frozenhatred.d951f264.png";